"use client";

import { Button, Heading, Modal, Text, TextButton } from "ui-components";

import { makeToast } from "@/src/components/Toast/Toast";
import { useJobDeleteOrganizationJobById } from "@/src/hooks/api/generated";
import { revalidateOrganizationPage } from "@/src/utils/revalidateOrganization";

export interface IDeleteJobModalProps {
  jobId: number;
  organizationId?: number;
  organizationSlug?: string;
  isOpen?: boolean;
  onOpenChange: (isOpen: boolean) => void;
  refetch?: () => void;
}

export function DeleteJobModal({
  jobId,
  organizationId,
  organizationSlug,
  isOpen,
  onOpenChange,
  refetch,
}: IDeleteJobModalProps): JSX.Element {
  const params = organizationId
    ? { organizationId: String(organizationId) }
    : undefined;
  const { mutate: deleteJob, status } = useJobDeleteOrganizationJobById();

  const handleDelete = (): void => {
    deleteJob(
      { id: jobId, params },
      {
        onSuccess: async () => {
          makeToast({
            intent: "success",
            title: "Job deleted successfully.",
          });
          // Refresh the org profile ISR cache so the reduced job count shows
          // immediately instead of waiting for the revalidate window.
          if (organizationSlug) {
            await revalidateOrganizationPage(organizationSlug);
          }
          refetch?.();
          onOpenChange(false);
        },
        onError: () => {
          makeToast({
            intent: "danger",
            title: "Something went wrong",
          });
          onOpenChange(false);
        },
      }
    );
  };
  return (
    <Modal
      isOpen={isOpen}
      onOpenChange={(value) => onOpenChange(value)}
      closeIcons
      isDismissable
      animatedModalClassName="md:min-w-[500px] flex flex-1 items-center justify-center"
    >
      <div className="flex flex-col items-center justify-start gap-10 pt-5">
        <Heading align="center">Delete job</Heading>
        <Text align="center">
          Are you sure you would like to delete this job?
        </Text>
        <div className="flex flex-col items-center justify-start gap-4">
          <Button
            onClick={handleDelete}
            isLoading={status === "pending"}
            isDisabled={status === "pending"}
          >
            <Text>Delete Job</Text>
          </Button>
          <TextButton underLine onPress={() => onOpenChange(false)}>
            Cancel
          </TextButton>
        </div>
      </div>
    </Modal>
  );
}
